import { render, staticRenderFns } from "./ReportStudentInter.vue?vue&type=template&id=e9fb377c"
import script from "./ReportStudentInter.vue?vue&type=script&lang=js"
export * from "./ReportStudentInter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports